import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { OrdersalesFisicaListComponent } from './ordersales-fisica-list/ordersales-fisica-list.component';
import { OrderSalesFisicaStep1Component } from './ordersales-fisica-step1/ordersales-fisica-step1.component';
import { OrdersalesFisicaStep1ListComponent } from './ordersales-fisica-step1-list/ordersales-fisica-step1-list.component';
import { OrdersalesFisicaStep2ListComponent } from './ordersales-fisica-step2-list/ordersales-fisica-step2-list.component';
import { OrdersalesFisicaStep3ListComponent } from './ordersales-fisica-step3-list/ordersales-fisica-step3-list.component';
import { OrdersalesFisicaStep4ListComponent } from './ordersales-fisica-step4-list/ordersales-fisica-step4-list.component';

@NgModule({
    imports: [
        SharedModule
    ],
    exports: [],
    declarations: [
        OrdersalesFisicaListComponent,
        OrderSalesFisicaStep1Component,
        OrdersalesFisicaStep1ListComponent,
        OrdersalesFisicaStep2ListComponent,
        OrdersalesFisicaStep3ListComponent,
        OrdersalesFisicaStep4ListComponent
    ],
    providers: [],
})
export class OrderSalesFisicaModule { }
